import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"
import { Mail, User2 } from "lucide-react"
import { ProfileData } from './Profile'

interface ProfileHeaderProps {
  profileData: ProfileData | null;
}

export default function ProfileHeader({ profileData }: ProfileHeaderProps) {
  if (!profileData) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-[125px] w-full" />
      </div>
    )
  }

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle>Profile</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-start space-x-4">
          <Avatar className="h-20 w-20">
            <AvatarImage src={profileData.avatar_url} alt={profileData.email || ''} />
            <AvatarFallback>
              <User2 className="h-10 w-10" />
            </AvatarFallback>
          </Avatar>
          <div className="space-y-2">
            <h2 className="text-2xl font-bold">{profileData.full_name || 'User'}</h2>
            <div className="flex items-center text-muted-foreground">
              <Mail className="mr-2 h-4 w-4" />
              <span>{profileData.email}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
